import React from "react";
import clsx from "clsx";

import { TableRow, TableCell } from "@material-ui/core";
import { alpha, makeStyles } from "@material-ui/core/styles";
import moment from "moment-jalaali";
import { Button } from "@mui/material";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  tableRowRoot: {
    position: "relative",
    transition: "all .2s",
    borderTop: `solid 1px ${theme.palette.borderColor.main}`,
    "&:hover, &.active": {
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      "& $tableCellRoot, & $titleRoot": {
        color: theme.palette.text.primary,
      },
    },
    "&:last-child": {
      borderBottom: `solid 1px ${theme.palette.borderColor.main}`,
    },
    "&:hover": {
      transform: "translateY(-4px)",
      boxShadow: `0 3px 10px 0 ${alpha(theme.palette.common.dark, 0.2)}`,
      borderTopColor: "transparent",
    },
    "&.collapse-table-row": {
      borderTop: "0 none",
      "& $tableCellRoot": {
        padding: 0,
      },
    },
    "&.active": {
      borderTop: "0 none",
      "&:hover": {
        transform: "none",
        boxShadow: "none",
      },
    },
  },
  tableCellRoot: {
    padding: 6,
    fontSize: 14,
    letterSpacing: 0.25,
    color: theme.palette.text.secondary,
    borderBottom: "0 none",
    position: "relative",
    "&:first-child": {
      paddingLeft: 24,
    },
    "&:last-child": {
      textAlign: "right",
      paddingRight: 24,
    },
  },
  titleRoot: {
    color: theme.palette.text.secondary,
    letterSpacing: 0.25,
  },
  removed: {
    opacity: 0.5,
    backgroundColor: alpha(theme.palette.error.main, 0.1),
  },
}));

const PurchasesTableItem = ({ data }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <TableRow
        className={clsx(classes.tableRowRoot, data.removed && classes.removed)}
      >
        <TableCell className={classes.tableCellRoot}>
          {data?.item?.name}
        </TableCell>
        <TableCell className={classes.tableCellRoot}>
          {data?.item?.inventory}
        </TableCell>
        <TableCell className={classes.tableCellRoot}>
          {data?.item?.price}
        </TableCell>
        <TableCell className={classes.tableCellRoot}>
          {data?.owner?.fullName}
        </TableCell>
        <TableCell className={classes.tableCellRoot}>
          {data?.owner?.nationalCode}
        </TableCell>
        <TableCell className={classes.tableCellRoot}>
          {moment(data.createdAt).format("jYYYY/jMM/jDD")}
        </TableCell>
        <TableCell className={classes.tableCellRoot}>
          <Button
            variant="text"
            color="error"
            onClick={() => history.push(`/purchaseDetails/${data._id}`)}
          >
            نمایش
          </Button>
        </TableCell>
      </TableRow>
    </>
  );
};

export default PurchasesTableItem;
